import { render, staticRenderFns } from "./SalaryIncurredConfigModal.vue?vue&type=template&id=4049ce6e"
import script from "./SalaryIncurredConfigModal.vue?vue&type=script&lang=js"
export * from "./SalaryIncurredConfigModal.vue?vue&type=script&lang=js"
import style0 from "./SalaryIncurredConfigModal.vue?vue&type=style&index=0&id=4049ce6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports